/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createManualConsumptionEntryFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type ManualConsumptionEntry, type ProblemDetails } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type DateOnly, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /chargepoints/{id}/consumption/manual
 */
export interface ManualRequestBuilder extends BaseRequestBuilder<ManualRequestBuilder> {
    /**
     * GetChargePointManualConsumptionEntries
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ManualConsumptionEntry[]>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<ManualRequestBuilderGetQueryParameters> | undefined) : Promise<ManualConsumptionEntry[] | undefined>;
    /**
     * GetChargePointManualConsumptionEntries
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ManualRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * GetChargePointManualConsumptionEntries
 */
export interface ManualRequestBuilderGetQueryParameters {
    from?: DateOnly;
    to?: DateOnly;
}
/**
 * Uri template for the request builder.
 */
export const ManualRequestBuilderUriTemplate = "{+baseurl}/chargepoints/{id}/consumption/manual{?From*,To*}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const ManualRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "from": "From",
    "to": "To",
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ManualRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ManualRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createManualConsumptionEntryFromDiscriminatorValue,
        queryParametersMapper: ManualRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
